import { Layout, Menu } from "antd";
import { useState, useEffect } from "react";
import Footer from "./Footer";
import Header from "./Header";
import {
  MailOutlined,
  PieChartOutlined,
  AppstoreOutlined,
  ShoppingCartOutlined,
  ShopOutlined,
  SettingOutlined,
  UserOutlined,
  AuditOutlined,
  FileDoneOutlined,
  SendOutlined,
  CalculatorOutlined,
  CustomerServiceOutlined
} from "@ant-design/icons";
import {message} from "antd";
import { Link } from "react-router-dom";

import { checkAccess } from "../../../access";
import { decrypt } from "../../../utils";
import "./menu.css";

const { Content, Sider } = Layout;

export const MainLayout = (props) => {
  function getItem(label, key, icon, id, children) {
    if (!checkAccess(id, userRole)) {
      return{
        key,
        icon,
        children,
        label,
        access:0,
        className:"no-access"
      }
    } else {
      return {
        key,
        icon,
        children,
        label,
        access:1,
      };
    }
  }

  const [userRole, setUserRole] = useState();

  const items = [
    getItem(
      "Usuarios",
      "1",
      <Link to="/users">
        {""}
        <UserOutlined />
        {""}
      </Link>,
      "users"
    ),
    getItem(
      "Registrar Venta",
      "2",
      <Link to="/add-sales">
        {" "}
        <MailOutlined />{" "}
      </Link>,
      "sales"
    ),
    getItem(
      "Pedidos",
      "3",
      <Link to="/orders">
        {" "}
        <ShoppingCartOutlined />{" "}
      </Link>,
      "orders"
    ),
    getItem("Tablero", "4", <PieChartOutlined />, "stats", [
      getItem("Ventas", "5", <Link to="/tablero-ventas" />, "salesStats"),
      getItem(
        "Marketing",
        "6",
        <Link to="/tablero-Marketing" />,
        "marketingStats"
      )      
    ]),
    getItem(
      "Operaciones",
      "7",
      <Link to="/tablero-operaciones">
        {" "}
        <CalculatorOutlined />{" "}
      </Link>,
      "storeStats"
    ),
    getItem(
      "Servicio al Cliente",
      "8",
      <Link to="/tablero-servicio-cliente">
        {" "}
        <CustomerServiceOutlined />{" "}
      </Link>,
      "customerServiceRead"
    ),
    getItem(
      "Finanzas",
      "9",
      <Link to="/tablero-finanzas" >
        <FileDoneOutlined />
      </Link>,
      "financeStats"
    ),
    getItem("Producto", "10", <MailOutlined />, "products", [
      getItem("Productos", "11", <Link to="/product" />, "products"),
      getItem("Tallas", "12", <Link to="/sizes" />, "products"),
      getItem("Proveedores", "13", <Link to="/providers" />, "products"),
      getItem("Couriers", "14", <Link to="/couriers" />, "products"),
    ]),
    getItem("Clientes", "15", <AppstoreOutlined />, "customers"),
    getItem("Tiendas", "16", <ShopOutlined />, "store"),
    getItem("Configuración", "17", <SettingOutlined />, "config"),
    getItem(
      "Auditoria",
      "18",
      <Link to="/auditing">
        {" "}
        <AuditOutlined />{" "}
      </Link>,
      "auditing"
    ),
    getItem(
      "Courier",
      "19",
      <Link to="/couriersBoard">
        {" "}
        <SendOutlined />{" "}
      </Link>,
      "courierStats"
    ),
  ];

  useEffect(() => {
    setInterval(async () => {
      if (!userRole && localStorage.getItem("role")) {
        setUserRole(await decrypt(localStorage.getItem("role")));
      }
    }, 2000);
  }, [userRole]);

  const handleClick = ({item}) => {
    if(!item.props.access){
      message.warning("Rol de usuario no cuenta con acceso a este modulo");
    }
  }

  return (
    <Layout
      style={{
        minHeight: "100vh",
      }}
    >
      <Header />
      <Layout style={{ marginTop: "86px" }}>
        <Sider breakpoint="lg" collapsedWidth="0">
          <Menu
            theme="dark"
            //defaultSelectedKeys={["13"]}
            mode="inline"
            items={items}
            onClick={handleClick}
          />
        </Sider>
        <Layout className="site-layout">
          <Content
            style={{
              margin: "0 16px",
            }}
          >
            <div className="site-layout-background">{props.children}</div>
          </Content>
          <Footer />
        </Layout>
      </Layout>
    </Layout>
  );
};
